// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__bVCL7"};